module.exports = __webpack_public_path__ + "static/media/nc4.f56344d3.png";